import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { CacheProvider } from '@emotion/react'
import { initMonitoring } from '@med/helpers/monitoring'
import * as Sentry from '@sentry/react'

import { store } from '@/store'

// Eager barrel import fixes Vite dev pre-bundle init order: MUI v6-alpha Box runs
// createTheme() at module load, which throws "createTheme_default is not a function"
// unless @mui/material is initialized first. Tree-shaken out of the production build.
import '@mui/material'
import './locales/i18n'

import { JWTProvider } from './contexts/JWTContext'
import App from './App'
import createEmotionCache from './emotionCache'

import 'react-toastify/dist/ReactToastify.css'

const nonce = import.meta.env.VITE_CSP_NONCE || 'xyz987'
const emotionCache = createEmotionCache(nonce)

initMonitoring({
  dsn: import.meta.env.VITE_APP_SENTRY_DSN,
  environment: import.meta.env.VITE_APP_ENV,
  release: __APP_RELEASE__,
  integrations: (defaultIntegrations) => [
    ...defaultIntegrations.filter(({ name }) => name !== 'BrowserSession'),
    Sentry.browserTracingIntegration(),
  ],
})

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <CacheProvider value={emotionCache}>
    <Provider store={store}>
      <BrowserRouter>
        <JWTProvider>
          <App />
        </JWTProvider>
        <ToastContainer />
      </BrowserRouter>
    </Provider>
  </CacheProvider>
)
